import { Controller } from 'stimulus';

const ACTIVE_CLASS = 'is-active';

export default class extends Controller {
  static targets = ['item'];
  static values = { groupId: String };

  /**
   * @param {PointerEvent} e
   */
  activate({ target }) {
    if (target.classList.contains(ACTIVE_CLASS)) {
      return;
    }

    for (const itemTarget of this.itemTargets) {
      itemTarget.classList.toggle(ACTIVE_CLASS, target === itemTarget);
    }

    this.dispatch(`${this.groupIdValue}:change`, { detail: { name: target.value } });
  }
}
